import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-500 focus:text-background-50 focus:rounded-lg">
        跳转到主要内容
      </a>

      <Header />

      <main id="main-content">
        <Hero />
        <AppSection />
        <IndexSection />
        <ContactSection />
        <CardsSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <FaqSection />
        <FeaturesSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
        <MediaSection />
      </main>

      <Footer />
    </div>
  );
}